import { filteredValues, formatUnit } from "@nitro/gatsby-source-harvia-pim/helpers/attribute"
import { ProductAttributeValue } from "@nitro/gatsby-source-harvia-pim/types/plugin"
import React from "react"
import * as styles from "./ProductAttribute.module.scss"
import { parseJSON } from "./utils"

type ProductAttributeProps = {
  list?: ProductAttributeValue[]
}

const ProductAttribute = (props: ProductAttributeProps) => {
  // console.debug("Rendering ProductAttribute", props)
  const { list } = props
  if (!list) {
    return null
  }

  if (!Array.isArray(list)) {
    return null
  }

  let isList = false

  const values = list.map((attr, i) => {
    // console.debug("Rendering ProductAttribute attr", attr)
    switch (attr.type) {
      case "ProductMetric": {
        const data = attr.metric
        if (isNaN(data.amount)) return <span key={i}>&nbsp;</span>
        return (
          <span key={`val-${i}-${data.amount}`}>
            {!isNaN(data.amount) ? data.amount : "-"}&nbsp;{formatUnit(data.unit)}
          </span>
        )
      }
      case "ProductOption":
        isList = true
        return (
          <li key={`val-${i}-${attr.text}`} className={styles.li}>
            {attr.text}
          </li>
        )
      case "number":
        return <span key={i}>{attr.numeric}</span>

      case "boolean":
        return <span key={i}>{attr.data ? "Yes" : "No"}</span>

      case "string": {
        const data = attr.text

        if (data === undefined) {
          return null
        }

        // Joidenkin kenttien arvo on json.
        const json = parseJSON(data) // JSON.parse(attr.data)

        if (typeof json !== "undefined" && json !== null) {
          //console.log(attr.attributeLabel, json, typeof json)

          //  Taulukko, esim "power_table" = '[["6,8","","",""]]'
          if (json.length && json[0] && json["map"]) {
            return (
              <table key={`table-${data}`}>
                <tbody>
                  {json.map((row: string[] | string, j: number) => {
                    // is array
                    if (row.length && row[0]) {
                      return (
                        <tr key={`tr-${i}-${j}`}>
                          {(row as string[]).map((itm, k) => {
                            return <td key={`td-${i}-${j}-${k}`} dangerouslySetInnerHTML={{ __html: itm }} />
                          })}
                        </tr>
                      )
                    } else {
                      return (
                        <tr key={`tr-${i}-${j}`}>
                          <td dangerouslySetInnerHTML={{ __html: row as string }} />
                        </tr>
                      )
                    }
                  })}
                </tbody>
              </table>
            )
          }

          // boolean arvo, Todo käännökset...
          if (typeof json == "boolean") {
            return <span key={`bool-${data}`}>{json ? "Yes" : "No"}</span>
          }
        }

        if (filteredValues.includes(data.toString())) {
          return <span key={`val-${data}`}>&nbsp;</span>
        }

        return <span key={`val-${data}`} dangerouslySetInnerHTML={{ __html: data.toString() }} /> // eh.. Joidenkin kenttien arvo on html:ää.
      }
      case "ProductPrice": {
        const data = attr.prices
        return (
          <span key={`val-${i}-${data[0].amount}`}>
            {data.map((itm, i) => (
              <span key={i}>
                {itm.amount}&nbsp;{formatUnit(itm.currency)}
              </span>
            ))}
          </span>
        )
      }

      default:
        console.warn("Unhandler attribute type:", attr.type)
        return <span key={i}>{attr.text}</span>
    }
  })

  if (isList) return <ul className={styles.ul}>{values}</ul>
  return <>{values}</>
}

export default ProductAttribute
